import {
  AttachMoney,
  AirportShuttle,
  Announcement,
  Assessment,
  Assignment,
  CalendarMonth,
  CameraSharp,
  Campaign,
  CandlestickChart,
  Cloud,
  DashboardCustomize,
  DeviceHub,
  Devices,
  Dvr,
  ExitToApp,
  Face,
  Login,
  ManageAccounts,
  Monitor,
  PortraitSharp,
  QrCode2,
  School,
  Settings,
  Shield,
  SportsTennis,
  SupportAgent,
  Timelapse,
  Videocam,
  Groups,
  ListAlt,
} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import Icon from '@mui/material/Icon';
import iconSchool from 'assets/images/icons/icons8-escola-64.png';
import AlarmCentralManagementVirtualPage from 'pages/AlarmCentralPages/AlarmCentralManagementPage/AlarmCentralManagementVirtualPage';
import AlarmCentralVirtualContextProvider from 'pages/AlarmCentralPages/context/AlarmCentralVirtualContext';
import Logout from 'pages/AuthenticationPages/_components/Logout';
import NewPassword from 'pages/AuthenticationPages/NewPasswordPage';
import RecoverPassword from 'pages/AuthenticationPages/RecoverPasswordPage';
import SignInPage from 'pages/AuthenticationPages/SignInPage';
import SignUpPage from 'pages/AuthenticationPages/SignUpPage';
import SignUpProductPage from 'pages/AuthenticationPages/SignUpProductPage';
import TokenPasswordPage from 'pages/AuthenticationPages/TokenPasswordPage';
import WelcomePage from 'pages/AuthenticationPages/WelcomePage';
import CommunicationPage from 'pages/CommunicationPage';
import DashboardPageClient from 'pages/DashboardPageClient';
import ControllersPage from 'pages/DevicesPages/ControllersPage';
import DvrPage from 'pages/DevicesPages/DvrPage';
import IntegrationPage from 'pages/IntegrationPage';
import MonitoringSchoolPerimeterPages from 'pages/MonitoringSchoolPerimeterPages';
import SchoolMonitoringPage from 'pages/SchoolMonitoringPage';
import React, { ReactNode } from 'react';
import { Permissions } from 'services/enums';
import AlarmCentralMainPage from '../pages/AlarmCentralPages/AlarmCentralMainPage';
import AlarmCentralPhysicalContextProvider from '../pages/AlarmCentralPages/context/AlarmCentralPhysicalContext';
import ConfigurationsPage from '../pages/ConfigurationsPage';
import CustomerMonitoringPage from '../pages/CustomerMonitoringPage';
import DefensePages from '../pages/DefensePages';
import ManagementPage from '../pages/ManagementPage';
import MonitoringPage from '../pages/MonitoringPage';
import ReportPage from '../pages/ReportPage';
import SportsPage from '../pages/SportsPages';
import CamsPage from 'pages/DevicesPages/CamsPage';
import ProposalPdfPage from 'pages/ProposalPdfPage';
import RecognitionsPage from '../pages/RecognitionPages/Recognitions';
import StorageIcon from '@mui/icons-material/Storage';
import FaceEditionContextProvider from '../pages/RecognitionPages/context/FaceEditionContextProvider';
import AlarmCentralManagementPhysicalPage from '../pages/AlarmCentralPages/AlarmCentralManagementPage/AlarmCentralManagementPhysicalPage';
import ServersPage from 'pages/ServersPage';
import SchoolTransportationPage from '../pages/SchoolTransportation';
import SchoolShiftList from '../pages/SchoolShiftPage/_components/SchoolShiftList';
import SchoolTicketPage from '../pages/SchoolTicketPage';
import SchoolBoardPage from '../pages/SchoolBoardPage';
import SipPage from '../pages/RemoteInspector';
import SipClientContextProvider from '../pages/RemoteInspector/context/SipClientContextProvider';
import { QRCodeLoginPage } from 'pages/AuthenticationPages/QRCodeLoginPage';
import SchoolClassList from '../pages/SchoolClass/_components/SchoolClassList';
import DeviceMonitoringScreen from '../pages/DeviceMonitoringScreen';
import LocationPage from '../pages/LocationPage';
import Map from '@mui/icons-material/Map';
import RecognitionGroupsList from '../pages/RecognitionPages/Groups';
import LicensePage from '../pages/LicensePage';
import NotificationLogsPage from 'pages/GeneralLogsPages/NotificationLogsPage';

const DEVICE_PAGE_ICON = <Videocam />;
const EVENT_PAGE_ICON = <CalendarMonth />;

function isManager() {
  const userType = localStorage.getItem('type');
  return userType == 'GERENTE';
}

export interface IRouteProps {
  type?: string;
  name?: string;
  key: string;
  icon?: ReactNode;
  route?: string;
  component?: ReactNode;
  protected?: boolean;
  isDisabled?: boolean;
  permissionId?: Permissions | Permissions[];
  collapse?: IRouteProps[];
}

const DEFAULT_ROUTE = '/app';

const routes: IRouteProps[] = [
  {
    type: 'collapse',
    name: 'routersNames.dashboard',
    key: 'dashboard',
    icon: <DashboardCustomize />,
    route: `${DEFAULT_ROUTE}/dashboardPageClient`,
    isDisabled: false,
    permissionId: [Permissions.DASHBOARD],
    component: <DashboardPageClient />,
    protected: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'DashboardPageResale',
  //   key: 'dashboardPageResale',
  //   icon: <DashboardCustomize />,
  //   route: `${DEFAULT_ROUTE}/dashboardPageResale`,
  //   isDisabled: false,
  //   permissionId: [Permissions.EVENTS, Permissions.DEVICES],
  //   component: <DashboardPageResale />,
  //   protected: true,
  // },

  // {
  //   type: 'collapse',
  //   name: 'VMS',
  //   key: 'vms',
  //   icon: <OndemandVideo />,
  //   route: `${DEFAULT_ROUTE}/vms`,
  //   permissionId: [Permissions.DEVICES],
  //   component: <VmsPage />,
  //   protected: true,
  // },
  {
    type: 'collapse',
    name: 'routersNames.proposalPdf',
    key: 'proposalPdf',
    icon: <PictureAsPdfIcon />,
    route: `${DEFAULT_ROUTE}/Proposal`,
    permissionId: [Permissions.ALL],
    component: <ProposalPdfPage />,
    protected: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'routersNames.financial',
  //   key: 'licenses',
  //   icon: <Assignment />,
  //   route: `${DEFAULT_ROUTE}/licenses`,
  //   permissionId: [Permissions.LICENSE],
  //   component: <LicensePage />,
  //   protected: true,
  // },
  // {
  //   type: 'collapse',
  //   name: 'routersNames.serversPage',
  //   key: 'serversPage',
  //   icon: <StorageIcon />,
  //   route: `${DEFAULT_ROUTE}/Servers`,
  //   permissionId: [Permissions.ALL],
  //   component: <ServersPage />,
  //   protected: true,
  // },
  {
    type: 'collapse',
    name: 'routersNames.monitoring',
    key: 'monit',
    icon: <Monitor />,
    permissionId: [Permissions.EVENTS],
    protected: true,
    collapse: [
      {
        type: 'collapse',
        name: 'routersNames.geral',
        key: 'monitoring',
        icon: <Dvr />,
        route: `${DEFAULT_ROUTE}/monitoring`,
        permissionId: [Permissions.EVENTS],
        component: <MonitoringPage />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.porter',
        key: 'opendoor',
        icon: <Dvr />,
        route: `${DEFAULT_ROUTE}/deviceOpenDoor`,
        permissionId: [Permissions.EVENTS],
        component: <DeviceMonitoringScreen />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.schoolMonitoring',
        key: 'school-Monitoring',
        icon: <School />,
        route: `${DEFAULT_ROUTE}/schoolMonitoring`,
        permissionId: [Permissions.SCHOOL_MONITORING_EVENT],
        component: <SchoolMonitoringPage />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.perimeterSchool',
        key: 'schoolMonitoring',
        icon: <img src={iconSchool} width={'20px'}></img>,
        route: `${DEFAULT_ROUTE}/MonitoringSchoolPerimeter`,
        permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
        component: <MonitoringSchoolPerimeterPages />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.customerMonitoring',
        key: 'customers',
        icon: <SupportAgent />,
        route: `${DEFAULT_ROUTE}/customers`,
        permissionId: [Permissions.CUSTOMER_RECOGNITION_EVENT],
        component: <CustomerMonitoringPage />,
        protected: true,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'routersNames.devices',
    key: 'devices',
    permissionId: Permissions.DEVICES,
    icon: <Devices />,
    protected: true,
    collapse: [
      {
        type: 'collapse',
        name: 'routersNames.cams',
        key: 'cams',
        icon: <CameraSharp />,
        route: `${DEFAULT_ROUTE}/devices/camera`,
        permissionId: [Permissions.DEVICES],
        component: <CamsPage />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.controllers',
        key: 'facialControl',
        icon: <PortraitSharp />,
        route: `${DEFAULT_ROUTE}/devices/facialControl`,
        permissionId: [Permissions.DEVICES],
        component: <ControllersPage />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'DVR/NVR/NVD',
        key: 'dvr',
        icon: <DeviceHub />,
        route: `${DEFAULT_ROUTE}/devices/dvr`,
        permissionId: [Permissions.DEVICES],
        component: <DvrPage />,
        protected: true,
      },
      {
        type: 'collapse',
        name: 'routersNames.centralAlarms',
        key: 'alarmCentral',
        route: `${DEFAULT_ROUTE}/alarmCentral`,
        icon: <UpcomingIcon />,
        permissionId: [Permissions.ALARM_CENTRAL],
        protected: true,
        component: <AlarmCentralMainPage />,
      },
      // {
      //   type: 'collapse',
      //   name: 'LPR',
      //   key: 'lpr',
      //   icon: <Garage />,
      //   route: `${DEFAULT_ROUTE}/devices/lpr`,
      //   permissionId: [Permissions.LPR_DEVICE, Permissions.DEVICES],
      //   component: <LprPage />,
      //   protected: true,
      // },
      // {
      //   type: 'collapse',
      //   name: 'IVS',
      //   key: 'ivs',
      //   icon: <Camera />,
      //   route: `${DEFAULT_ROUTE}/devices/ivs`,
      //   permissionId: [Permissions.IVS_DEVICE, Permissions.DEVICES],
      //   component: <IvsPage />,
      //   protected: true,
      // },
      // {
      //   type: 'collapse',
      //   name: 'Temperatura',
      //   key: 'temp',
      //   icon: <Thermostat />,
      //   route: `${DEFAULT_ROUTE}/devices/temperature`,
      //   permissionId: [
      //     Permissions.TEMPERATURE_DETECTOR_DEVICE,
      //     Permissions.DEVICES,
      //   ],
      //   component: <TemperatureDetectorPage />,
      //   protected: true,
      // },
      // {
      //   type: 'collapse',
      //   name: 'DVR',
      //   key: 'dvr',
      //   icon: <DeviceHub />,
      //   route: `${DEFAULT_ROUTE}/devices/dvr`,
      //   permissionId: [Permissions.DEVICES, Permissions.DVR_DEVICE],
      //   component: <DvrPage />,
      //   protected: true,
      // },
    ],
  },
  {
    type: 'collapse',
    name: 'routersNames.registerFaces',
    key: 'face-recognition',
    icon: <Face />,
    route: `${DEFAULT_ROUTE}/recognitions`,
    permissionId: [Permissions.FACE_REGISTER],
    component: (
      <FaceEditionContextProvider>
        <RecognitionsPage />
      </FaceEditionContextProvider>
    ),
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Grupos Faciais',
    key: 'face-groups',
    icon: <Groups />,
    route: `${DEFAULT_ROUTE}/facegroups`,
    permissionId: [Permissions.FACE_REGISTER],
    component: (
      <FaceEditionContextProvider>
        <RecognitionGroupsList />
      </FaceEditionContextProvider>
    ),
    protected: true,
  },
  {
    key: 'alarmCentralPhysicalDetails',
    icon: <Icon fontSize="small">bell</Icon>,
    route: `${DEFAULT_ROUTE}/alarmCentral/physical/:id`,
    permissionId: Permissions.ALARM_CENTRAL,
    component: (
      <AlarmCentralPhysicalContextProvider>
        <AlarmCentralManagementPhysicalPage />
      </AlarmCentralPhysicalContextProvider>
    ),
    protected: false,
  },
  {
    key: 'alarmCentralVirtualDetails',
    icon: <Icon fontSize="small">bell</Icon>,
    route: `${DEFAULT_ROUTE}/alarmCentral/virtual/:id`,
    permissionId: Permissions.ALARM_CENTRAL,
    component: (
      <AlarmCentralVirtualContextProvider>
        <AlarmCentralManagementVirtualPage />
      </AlarmCentralVirtualContextProvider>
    ),
    protected: false,
  },
  {
    type: 'collapse',
    name: 'routersNames.sports',
    key: 'sports',
    route: `${DEFAULT_ROUTE}/sports`,
    icon: <SportsTennis />,
    permissionId: Permissions.SPORT_UNITIES,
    protected: true,
    component: <SportsPage />,
  },
  {
    type: 'collapse',
    name: 'routersNames.integrationsPage',
    key: 'integracao',
    icon: <Cloud />,
    permissionId: Permissions.INTEGRATIONS,
    route: `${DEFAULT_ROUTE}/integrations`,
    component: <IntegrationPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'DefenseIA',
    key: 'defense',
    isDisabled: false,
    icon: <Shield />,
    permissionId: Permissions.DEFENSE_INTEGRATION,
    route: `${DEFAULT_ROUTE}/defense`,
    component: <DefensePages />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Localização',
    key: 'location',
    icon: <Map />,
    route: `${DEFAULT_ROUTE}/location`,
    permissionId: [Permissions.LOCATION],
    component: <LocationPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.configuration',
    key: 'config',
    icon: <Settings />,
    permissionId: Permissions.CONFIG,
    route: `${DEFAULT_ROUTE}/configurations`,
    component: <ConfigurationsPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.management',
    key: 'management',
    icon: <ManageAccounts />,
    route: `${DEFAULT_ROUTE}/management`,
    component: <ManagementPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.communicationPage',
    key: 'communication',
    icon: <Campaign />,
    route: `${DEFAULT_ROUTE}/communication`,
    component: <CommunicationPage />,
    permissionId: [Permissions.COMMUNICATION],
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.remoteTax',
    key: 'remoteInspector',
    icon: <SupportAgent />,
    route: `${DEFAULT_ROUTE}/remoteInspector`,
    permissionId: [Permissions.SIP_CLIENT],
    component: (
      <SipClientContextProvider>
        <SipPage />
      </SipClientContextProvider>
    ),
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.report',
    key: 'report',
    icon: <Assessment />,
    route: `${DEFAULT_ROUTE}/report`,
    permissionId: [Permissions.DEVICES],
    component: <ReportPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'routersNames.notificationLogs',
    key: 'notification-logs',
    icon: <ListAlt />,
    route: `${DEFAULT_ROUTE}/notification-logs`,
    permissionId: [Permissions.ALL], 
    component: <NotificationLogsPage />,
    protected: true,
  },
  {
    type: 'hide',
    name: 'Sign In',
    key: 'sign-in',
    icon: <Login />,
    route: `${DEFAULT_ROUTE}/authentication/signIn`,
    component: <SignInPage />,
  },
  {
    type: 'hide',
    name: 'Token Password',
    key: 'token-password',
    icon: <Login />,
    route: `${DEFAULT_ROUTE}/authentication/tokenPassword`,
    component: <TokenPasswordPage />,
  },
  {
    type: 'collapse',
    name: 'routersNames.trans',
    key: 'trans',
    icon: <AirportShuttle />,
    route: `${DEFAULT_ROUTE}/trans`,
    permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
    component: <SchoolTransportationPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Turma',
    key: 'class',
    icon: <School />,
    route: `${DEFAULT_ROUTE}/class`,
    permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
    component: <SchoolClassList />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Turno',
    key: 'turn',
    icon: <Timelapse />,
    route: `${DEFAULT_ROUTE}/turn`,
    permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
    component: <SchoolShiftList />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Ticket Escolar',
    key: 'ticket',
    icon: <CandlestickChart />,
    route: `${DEFAULT_ROUTE}/ticket`,
    permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
    component: <SchoolTicketPage />,
    protected: true,
  },
  {
    type: 'collapse',
    name: 'Mensageria',
    key: 'school-board-menu-item',
    icon: <Announcement />,
    route: `${DEFAULT_ROUTE}/schoolboard`,
    component: <SchoolBoardPage />,
    permissionId: [Permissions.SCHOOL_BOARD_READ],
    protected: true,
  },
  {
    type: 'hide',
    name: 'Sign Up',
    key: 'sign-up',
    icon: <Assignment />,
    route: `${DEFAULT_ROUTE}/authentication/signUp`,
    component: <SignUpPage />,
  },
  {
    type: 'hide',
    name: 'SignUp Product',
    key: 'signUp-product',
    icon: <Assignment />,
    route: `${DEFAULT_ROUTE}/authentication/signUpProduct`,
    component: <SignUpProductPage />,
  },
  {
    type: 'hide',
    name: 'SignUpWelcome',
    key: 'signUp-welcome',
    icon: <Assignment />,
    route: `${DEFAULT_ROUTE}/authentication/Welcome`,
    component: <WelcomePage />,
  },
  {
    type: 'hide',
    name: 'Recover Password',
    key: 'recover-password',
    icon: <Assignment />,
    route: `${DEFAULT_ROUTE}/authentication/recoverPassword`,
    component: <RecoverPassword />,
  },
  {
    type: 'hide',
    name: 'New Password',
    key: 'new-password',
    icon: <Assignment />,
    route: `${DEFAULT_ROUTE}/authentication/newPassword`,
    component: <NewPassword />,
  },
  {
    type: 'hide',
    name: 'QRCodeLogin',
    key: 'qrcode-login',
    icon: <QrCode2 />,
    route: `${DEFAULT_ROUTE}/auth/QRCode/login/:token?`,
    component: <QRCodeLoginPage />,
  },
  {
    type: 'hide',
    name: 'routersNames.logout',
    key: 'logout',
    icon: <ExitToApp />,
    route: `${DEFAULT_ROUTE}/logout`,
    component: <Logout />,
  },
];

// if (isManager()) {
//   routes.splice(Math.floor(routes.length / 2), 0, {
//     type: 'collapse',
//     name: 'Usuários',
//     key: 'userPage',
//     disabled: true,
//     icon: <People />,
//     route: '${DEFAULT_ROUTE/users',
//     component: <UserListPage />,
//     protected: true,
//   });
// }

export default routes;
